import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../../../components/public/Footer';

export default function MentionsLegales() {
  const [lang, setLang] = useState('En');

  useEffect(() => {
    const syncLang = () => {
      setLang((localStorage.getItem('januslang') || localStorage.getItem('janus_lang')) === 'Fr' ? 'Fr' : 'En');
    };
    syncLang();
    window.addEventListener('langchange', syncLang);
    window.addEventListener('januslangchanged', syncLang);
    return () => {
      window.removeEventListener('langchange', syncLang);
      window.removeEventListener('januslangchanged', syncLang);
    };
  }, []);

  const translations = {
    Fr: {
      metaTitle: "Mentions Legales | Janus Capital Strategy",
      metaDesc: "Mentions legales du site Janus Capital Strategy.",
      title: "Mentions Legales",
      sections: [
        { h: "Editeur du site", p: "Janus Capital Strategy W.L.L., immatriculée au Royaume de Bahreïn, RC n° 1-181029. Janus Capital Strategy ne détient aucun enregistrement CIF ni licence VARA, ne fournit aucun conseil en investissement réglementé et ne détient aucun fonds de clients. Les contenus publiés sont fournis à titre informatif uniquement et ne constituent pas un conseil en investissement personnalisé.\nRaison sociale : Janus Capital Strategy W.L.L.\nSiège social : Royaume de Bahreïn" },
        { h: "Hebergement", p: "Hostinger International Ltd., 61 Lordou Vironos Street, 6023 Larnaca, Chypre. www.hostinger.com" },
        { h: "Propriete intellectuelle", p: "L'ensemble des contenus presents sur ce site (textes, images, logos, graphismes) sont la propriete exclusive de Janus Capital Strategy ou de ses partenaires, sauf mention contraire. Toute reproduction, meme partielle, est interdite sans autorisation prealable." },
        { h: "Responsabilite", p: "Janus Capital Strategy s'efforce d'assurer l'exactitude des informations diffusees sur ce site, mais ne peut garantir l'exhaustivite ou l'absence de modification des informations mises a disposition. Janus Capital Strategy ne pourra etre tenu responsable des dommages directs ou indirects resultant de l'acces ou de l'utilisation de ce site." }
      ]
    },
    En: {
      metaTitle: "Legal Notice | Janus Capital Strategy",
      metaDesc: "Legal notice for the Janus Capital Strategy website.",
      title: "Legal Notice",
      sections: [
        { h: "Website Publisher", p: "Janus Capital Strategy W.L.L., registered in the Kingdom of Bahrain, CR No. 1-181029. Janus Capital Strategy holds no CIF registration or VARA licence, provides no regulated investment advice and holds no client funds. Published content is for information only and does not constitute personalised investment advice.\nLegal entity: Janus Capital Strategy W.L.L.\nRegistered office: Kingdom of Bahrain" },
        { h: "Hosting", p: "Hostinger International Ltd., 61 Lordou Vironos Street, 6023 Larnaca, Cyprus. www.hostinger.com" },
        { h: "Intellectual Property", p: "All content on this website (text, images, logos, graphics) is the exclusive property of Janus Capital Strategy or its partners, unless otherwise stated. Any reproduction, even partial, is prohibited without prior authorization." },
        { h: "Liability", p: "Janus Capital Strategy strives to ensure the accuracy of information published on this website, but cannot guarantee its completeness or that it remains unaltered. Janus Capital Strategy cannot be held liable for direct or indirect damages resulting from access to or use of this website." }
      ]
    },
    Ar: {
      metaTitle: "الإشعار القانوني | جانوس كابيتال ستراتيجي",
      metaDesc: "الإشعار القانوني لموقع جانوس كابيتال ستراتيجي.",
      title: "الإشعار القانوني",
      sections: [
        { h: "ناشر الموقع", p: "يتم نشر موقع januscapitalstrategy.com من قبل جانوس كابيتال ستراتيجي.\nالكيان القانوني: [يُستكمل وفق الهيكل القانوني الفعلي]\nالمقر المسجل: دبي، الإمارات العربية المتحدة\nالبريد الإلكتروني للتواصل: contact@yemventure.com\nالهاتف: +971 50 821 8831" },
        { h: "مدير النشر", p: "[الاسم والمنصب يُستكملان]" },
        { h: "الاستضافة", p: "[اسم مزود الاستضافة والعنوان ورقم الهاتف يُستكملان]" },
        { h: "التسجيل", p: "[رقم الترخيص أو ضريبة القيمة المضافة أو TRN أو RERA أو أي مراجع أخرى تُستكمل وفق هيكلكم الفعلي]" },
        { h: "الملكية الفكرية", p: "جميع المحتويات الموجودة على هذا الموقع (نصوص، صور، شعارات، تصاميم) هي ملكية خالصة لجانوس كابيتال ستراتيجي أو شركائها، ما لم يُذكر خلاف ذلك. يُمنع أي نسخ، حتى الجزئي، دون إذن مسبق." },
        { h: "المسؤولية", p: "تسعى جانوس كابيتال ستراتيجي لضمان دقة المعلومات المنشورة على هذا الموقع، ولكنها لا تضمن اكتمالها أو عدم تغييرها. لا يمكن تحميل جانوس كابيتال ستراتيجي المسؤولية عن أي أضرار مباشرة أو غير مباشرة ناتجة عن الوصول إلى هذا الموقع أو استخدامه." }
      ]
    }
  };

  const t = translations[lang] || translations.En;
  const isRtl = false;

  return (
    <div className="janus-page min-h-screen font-sans" dir={isRtl ? 'rtl' : 'ltr'}>
      <Helmet>
        <title>{t.metaTitle}</title>
        <meta name="description" content={t.metaDesc} />
      </Helmet>
      <section className="pt-40 pb-24 px-6 lg:px-12 max-w-[900px] mx-auto">
        <h1 className="text-3xl md:text-4xl font-light tracking-wide mb-10 janus-title uppercase">{t.title}</h1>
        <div className="space-y-6 janus-text-muted font-light leading-relaxed text-justify">
          {t.sections.map((s, i) => (
            <p key={i}><strong>{s.h}</strong><br/>{s.p.split('\n').map((line, j) => (<React.Fragment key={j}>{line}<br/></React.Fragment>))}</p>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
